"use client";

import { Cpu, TrendingUp, Upload, Zap } from "lucide-react";
import { useJsonTranslation } from "@/hooks/useJsonTranslation";

const steps = [
  {
    step: "01",
    icon: Upload,
    titleKey: "steps.upload.title",
    descKey: "steps.upload.description",
  },
  {
    step: "02",
    icon: Cpu,
    titleKey: "steps.analyzes.title",
    descKey: "steps.analyzes.description",
  },
  {
    step: "03",
    icon: Zap,
    titleKey: "steps.assets.title",
    descKey: "steps.assets.description",
  },
  {
    step: "04",
    icon: TrendingUp,
    titleKey: "steps.results.title",
    descKey: "steps.results.description",
  },
];

export function HowItWorks() {
  const { t } = useJsonTranslation("HomeHowItWorks");

  return (
    <div
      data-home-block="process-flow"
      className="relative px-5 py-6 sm:px-7 sm:py-8"
    >
      <div>
        <div className="mb-12 text-center">
          <div className="home-eyebrow mb-4">
            {t("eyebrow")}
          </div>
          <h2 className="home-section-title text-3xl text-balance md:text-4xl lg:text-5xl">
            {t("title")}
          </h2>
          <p className="home-section-copy mx-auto mt-5 max-w-3xl text-lg text-pretty">
            {t("subtitle")}
          </p>
        </div>

        <div className="relative grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {/* Connecting line (desktop only, behind cards) */}
          <div
            className="from-leaf-500/0 via-leaf-500/40 to-leaf-500/0 pointer-events-none absolute top-[5.5rem] right-[4%] left-[4%] hidden h-px bg-gradient-to-r lg:block"
            aria-hidden="true"
          />

          {steps.map((item, i) => (
            <div
              key={i}
              className="uni-card group relative z-10 overflow-hidden text-center"
            >
              {/* Step number watermark */}
              <div className="font-display text-foreground/[0.05] pointer-events-none absolute top-3 right-4 text-6xl leading-none font-black select-none">
                {item.step}
              </div>

              {/* Step chip */}
              <div className="home-badge relative z-10 mx-auto mb-5 px-3 py-1 text-xs font-bold uppercase">
                {t("stepLabel", { number: item.step })}
              </div>

              <div className="relative flex flex-col items-center">
                <div className="home-icon-tile mb-5 h-14 w-14 transition-transform duration-300 group-hover:scale-105">
                  <item.icon className="h-7 w-7" />
                </div>
                <h3 className="font-display text-foreground mb-2.5 text-lg font-semibold">
                  {t(item.titleKey)}
                </h3>
                <p className="home-section-copy mx-auto max-w-xs text-sm">
                  {t(item.descKey)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
